import React, {Component} from 'react';
import {
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand,
  NavLink
} from 'reactstrap';
import {connect} from 'react-redux';

import {
  actions as authActions
} from 'App/util/redux/auth/index';

import * as helper from 'App/util/common/helper';
import FullHeaderUserInfo from './FullHeaderUserInfo';

const {
  authLogout
} = authActions;


const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  authLogout: (cb_success) => dispatch(authLogout(cb_success))
});

@connect(
  mapStateToProps,
  mapDispatchToProps
)
class FullHeader extends Component {

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  logout(e) {
    // pass in a callback function which is called if logout succeeds
    this.props.authLogout((dispatch) => helper.cb_logout(dispatch));
  }

  render() {
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <NavbarBrand href="#"></NavbarBrand>
        <NavbarToggler className="d-md-down-none mr-auto" onClick={this.sidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>

        <Nav navbar>
          <FullHeaderUserInfo/>
          <NavItem className="px-3" id="logout-btn">
            <NavLink href="#" onClick={(e) => this.logout(e)}>
              <i className="icon-power"></i>
            </NavLink>
          </NavItem>
        </Nav>
      </header>
    );
  }
}

export default FullHeader;



// WEBPACK FOOTER //
// ./src/containers/Full/FullHeader.js